import Icon from "@/components/Icon";
import { Reveal } from "@/lib/motionSafe";
import { useSettings } from "@/lib/useSettings";

export default function Testimonials({ items = [] }) {
  const { settings } = useSettings();
  if (!items.length) return null;
  return (
    <section className="py-20 md:py-28 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <span className="aman-tag-dark">آراء عملائنا</span>
            <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A1628] leading-tight">
              {settings?.testimonials_section_title_ar || "ثقة تُبنى بالإنجاز"}
            </h2>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12">
          {items.map((t, i) => (
            <Reveal key={t.id || t.name_ar} delay={i * 80}>
              <div className="aman-card p-7 h-full">
                <div className="flex gap-1 text-[#00b8cc]">
                  {Array.from({ length: t.rating || 5 }).map((_, k) => (
                    <Icon key={k} name="star" size={18} strokeWidth={2} className="fill-[#00b8cc]" />
                  ))}
                </div>
                <p className="mt-4 text-slate-700 text-base leading-loose">“{t.quote_ar}”</p>
                <div className="mt-5 pt-5 border-t border-slate-100">
                  <div className="font-heading font-bold text-[#0A1628]">{t.name_ar}</div>
                  <div className="text-slate-500 text-sm mt-0.5">{t.role_ar}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
